import React from 'react';
import { Alert } from '@mui/material';

interface Props {
  participantsCount: number;
  declaredParticipantsCount?: number | null;
}

const ReservationHeadcountValidationAlert: React.FC<Props> = ({
  participantsCount,
  declaredParticipantsCount,
}) => {
  const hasParticipants = participantsCount > 0;
  const hasDeclaredCount = Number(declaredParticipantsCount) > 0;

  if (hasParticipants) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        Efektywna liczba uczestników jest wyliczana na podstawie wierszy uczestników. Kod:{' '}
        <strong>RES_EFFECTIVE_COUNT_FROM_ROWS</strong>
      </Alert>
    );
  }

  if (!hasDeclaredCount) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        Deklarowana liczba uczestników jest wymagana, gdy lista uczestników jest pusta. Kod:{' '}
        <strong>RES_DECLARED_COUNT_REQUIRED</strong>
      </Alert>
    );
  }

  return (
    <Alert severity="success" sx={{ mb: 2 }}>
      Liczba uczestników rezerwacji jest poprawna (tryb deklarowanej liczby).
    </Alert>
  );
};

export default ReservationHeadcountValidationAlert;
